import { FC } from 'react';

interface Props {
  color?: string;
  className?: string;
}

const StarSvg: FC<Props> = ({ className, color }) => {
  return (
    <svg
      className={className}
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill={color ?? 'currentColor'}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M22.5 12.0005V13.9997L22 13.9997C22 16.2088 20.2092 17.9995 18.0002 17.9995H17C15.8954 17.9995 15 17.1041 15 15.9995V11.9999C15 10.8954 15.8954 9.99995 17 9.99995H18.0002C19.0131 9.99995 19.9381 10.3765 20.6428 10.9971C20.1453 6.66486 16.4655 3.30049 12 3.30049C7.67679 3.30049 4.09008 6.45382 3.41442 10.5859C4.02163 10.2142 4.73569 9.99995 5.49979 9.99995H6.5C7.60457 9.99995 8.5 10.8954 8.5 11.9999V15.9995C8.5 17.1041 7.60457 17.9995 6.5 17.9995H5.49979C3.29077 17.9995 1.5 16.2088 1.5 13.9997V12.0005C1.5 6.2015 6.20101 1.50049 12 1.50049C17.799 1.50049 22.5 6.2015 22.5 12.0005ZM5.49979 11.7999H6.5C6.61046 11.7999 6.7 11.8895 6.7 11.9999V15.9995C6.7 16.11 6.61046 16.1995 6.5 16.1995H5.49979C4.28488 16.1995 3.3 15.2146 3.3 13.9997C3.3 12.7848 4.28488 11.7999 5.49979 11.7999ZM17 11.7999H18.0002C19.2151 11.7999 20.2 12.7848 20.2 13.9997C20.2 15.2146 19.2151 16.1995 18.0002 16.1995H17C16.8895 16.1995 16.8 16.11 16.8 15.9995V11.9999C16.8 11.8895 16.8895 11.7999 17 11.7999ZM13 17.9995H12.3333C11.597 17.9995 11 18.5965 11 19.3328V20.6662C11 21.4026 11.597 21.9995 12.3333 21.9995H13C14.1046 21.9995 15 21.1041 15 19.9995C15 18.8949 14.1046 17.9995 13 17.9995Z'
        fill={color ?? 'currentColor'}
      />
      <path
        d='M13 21.0005H15.5992C18.8739 21.0005 21.5438 18.3747 21.5983 15.1005L21.6 15.0005V13.0005'
        stroke={color ?? 'currentColor'}
        stroke-width='1.8'
      />
    </svg>
  );
};

export default StarSvg;
